// src/redux/settingsPages/accessibility/accessibilityAPI.js
import apiClient from '../../authentication/utils/core/axios';

const AccessibilityAPI = {
  async getSettings() {
    const res = await apiClient.get('/settings/accessibility');
    return res.data;
  },

  async updateSettings(patch) {
    const res = await apiClient.patch('/settings/accessibility', patch);
    return res.data;
  },

  async resetSettings() {
    const res = await apiClient.post('/settings/accessibility/reset');
    return res.data;
  },
};

export default AccessibilityAPI;
